import React from 'react';
import { Flex, Icon, Text } from '@chakra-ui/react';
import { FiAlertTriangle } from 'react-icons/fi';
import { getRefundDeadlineInfo } from 'api/administrador/refunds';

const BANNER_STYLES = {
  warning: {
    bg: '#FFFBEB',
    border: '#FCD34D',
    icon: '#D97706',
    text: '#92400E',
  },
  overdue: {
    bg: '#FEF2F2',
    border: '#FCA5A5',
    icon: '#DC2626',
    text: '#991B1B',
  },
};

export default function RefundDeadlineBanner({ refund }) {
  const info = getRefundDeadlineInfo(refund);

  if (!info.applies || info.deadlineStatus === 'ok') {
    return null;
  }

  const styles = BANNER_STYLES[info.deadlineStatus];
  const message =
    info.deadlineStatus === 'overdue'
      ? `El plazo de ${info.businessDaysLimit} días hábiles para devolver al estudiante venció el ${info.dueDateFormatted}. Prioriza este caso.`
      : `El plazo vence el ${info.dueDateFormatted}${info.statusDetail ? ` (${info.statusDetail})` : ''}. Compromiso: ${info.businessDaysLimit} días hábiles desde el registro (${info.registeredAtFormatted}).`;

  return (
    <Flex
      bg={styles.bg}
      border="1px solid"
      borderColor={styles.border}
      borderRadius="md"
      p={4}
      mb={4}
      align="flex-start"
      gap={3}
    >
      <Icon as={FiAlertTriangle} color={styles.icon} mt={0.5} boxSize={4} />
      <Text fontSize="sm" color={styles.text} lineHeight="tall">
        {message}
      </Text>
    </Flex>
  );
}
